// NEW: UI_REVAMP
export const normalizeStatusKey = (value = '') =>
	String(value)
		.toLowerCase()
		.replace(/[\s_-]+/g, '');
